class Service {
  splitQuantityBoxesAndRemaining(quantity, quantityPerBox) {
    return {
      boxes: quantityPerBox > 0 ? Math.floor(Number(quantity) / Number(quantityPerBox)) : 0,
      remaining: quantityPerBox > 0 ? Number(quantity) % Number(quantityPerBox) : Number(quantity),
    };
  }
}

export default new Service();



// WEBPACK FOOTER //
// ./src/layer/services/stock.js